import { faqItems } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 bg-accent-100 text-accent-700 text-xs font-semibold px-3 py-1 rounded-full mb-4">
            <i className="ri-question-answer-line text-sm"></i>
            答疑解惑
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 font-heading mb-3">
            常见问题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            关于91黑料吃瓜平台的常见疑问，这里为你一一解答
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-2xl border border-background-200 overflow-hidden"
            >
              <div className="p-5 md:p-6">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0 mt-0.5">
                    <i className="ri-question-line text-sm"></i>
                  </div>
                  <div>
                    <h3 className="text-foreground-950 text-sm font-bold mb-2">
                      {item.question}
                    </h3>
                    <p className="text-foreground-600 text-sm leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}